import { render, staticRenderFns } from "./settingPaper.vue?vue&type=template&id=3e82b04c&scoped=true&"
import script from "./settingPaper.vue?vue&type=script&lang=js&"
export * from "./settingPaper.vue?vue&type=script&lang=js&"
import style0 from "./settingPaper.vue?vue&type=style&index=0&id=3e82b04c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82b04c",
  null
  
)

export default component.exports